import { ShoppingBag, Truck, Home } from "lucide-react";
import { Eyebrow } from "./Brand";
import { Reveal } from "./Motion";

const STEPS = [
  [ShoppingBag, "Pick up", "Buy something on Marketplace or from a local seller. Request a pickup in the app."],
  [Truck, "Transport", "A nearby driver with the right vehicle grabs it. You always see the price first."],
  [Home, "Deliver", "Your item arrives at your door, and you can follow it on a live map."],
];

export const HowItWorks = () => (
  <section id="how-it-works" className="py-20 sm:py-32 bg-white" data-testid="how-it-works-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-10">
      <div className="grid lg:grid-cols-12 gap-8">
        <Reveal className="lg:col-span-5">
          <Eyebrow>For customers · coming soon</Eyebrow>
          <h2 className="font-display text-4xl sm:text-6xl font-extrabold tracking-tight text-[#13296B] mt-4 leading-[0.95]">Buy it anywhere. We'll ship it to your door.</h2>
          <p className="mt-6 text-slate-600 text-base sm:text-lg">Bought a couch on Marketplace? Scored a deal from a local seller? Marketgetr brings it home.</p>
        </Reveal>
        <div className="lg:col-span-7 lg:pl-10">
          {STEPS.map(([Icon, title, text], i) => (
            <Reveal key={title} delay={i * 0.1}>
              <div className="group flex gap-6 border-t border-slate-200 py-8" data-testid={`how-step-${i + 1}`}>
                <span className="font-mono text-sm text-[#2F7FF0] pt-2">0{i + 1}</span>
                <div className="flex-1">
                  <h3 className="font-display text-3xl sm:text-4xl font-bold text-[#13296B] transition-transform duration-500 group-hover:translate-x-2">{title}</h3>
                  <p className="mt-2 text-slate-600 max-w-md">{text}</p>
                </div>
                <span className="h-14 w-14 shrink-0 rounded-2xl bg-[#F0F5FD] flex items-center justify-center transition-colors duration-300 group-hover:bg-[#2F7FF0]">
                  <Icon className="h-6 w-6 text-[#13296B] group-hover:text-white transition-colors duration-300" />
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
